import { ActivityFilterKey } from '@gripp/shared-logic';
import {
  ActivityList,
  SlideAction,
  SlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ActivityFilters } from '../../activity/components/activityFilters';
import { Issue } from '../../issues/components/issue';
import { useAssetRouting } from '../assetRouteContext';
import { RoutineSubmitSource } from '../assetUtils';
import { AssetCard } from './assetCard';
import { AssetFilters } from './assetFilters';

export const AssetActivity = () => {
  const { assetId, issueId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { basePath } = useAssetRouting(assetId ?? '');

  if (!assetId) {
    return null;
  }

  const from: RoutineSubmitSource | undefined = location.state?.from;
  const cameFromAsset = from === RoutineSubmitSource.AssetCard;

  const leftColumn = {
    title: cameFromAsset ? 'assets.menu.title' : 'activity.header.title',
    mainComponent: cameFromAsset
      ? <AssetCard assetId={assetId} forceShowing />
      : <LeftColumn assetId={assetId} selectedIssue={issueId} />,
    headerComponent: cameFromAsset
      ? <AssetFilters assetId={assetId} />
      : <ActivityFilters />,
    showBackButton: true,
    disableScroll: cameFromAsset ? false : true,
    onBackButtonPress: () => {
      navigate(basePath);
    },
    backButtonTransition: SlideAction.PREV,
  };

  const rightColumn = {
    title: 'assets.menu.title',
    showHeader: false,
    disableScroll: true,
    mainComponent: <Issue />,
  };

  return (
    <SlideLayout
      leftColumn={leftColumn}
      rightColumn={rightColumn}
      viewMode={ViewMode.DUAL}
    />
  );
};

const LeftColumn = ({
  assetId,
  selectedIssue,
}: {
  assetId: string;
  selectedIssue?: string;
}) => {
  const navigate = useNavigate();

  const onIssueSelected = (issueId: string) => {
    navigate(`/assets/${assetId}/activity/${issueId}`);
  };

  return (
    <ActivityList
      filterKey={ActivityFilterKey.AssetActivity}
      onIssueSelected={onIssueSelected}
      assetId={assetId}
      showAssetName={false}
      showImage={false}
      pageSize={50}
      selectedIssue={selectedIssue}
    />
  );
};
